import { ApiAttributionModel, ApiMetric } from "@incendium/api";
import { AttributionMetric } from "features/analytics/types/types";

// Define metric groups by attribution type and model
const attributionMetricGroups = {
  [AttributionMetric.REVENUE]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_REVENUE,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_REVENUE_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_REVENUE_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_REVENUE_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_REVENUE_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_REVENUE_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_REVENUE_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_REVENUE_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_REVENUE_POSITION_BASED,
  },
  [AttributionMetric.SALES]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_SALES_COUNT,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_SALES_COUNT_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_SALES_COUNT_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_SALES_COUNT_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_SALES_COUNT_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_SALES_COUNT_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_SALES_COUNT_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_SALES_COUNT_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_SALES_COUNT_POSITION_BASED,
  },
  [AttributionMetric.MACRO]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT_POSITION_BASED,
  },
  [AttributionMetric.MACRO_RATE]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_MACRO_CONVERSION_RATE,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_MACRO_CONVERSION_RATE_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_MACRO_CONVERSION_RATE_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_MACRO_CONVERSION_RATE_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_MACRO_CONVERSION_RATE_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_MACRO_CONVERSION_RATE_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_MACRO_CONVERSION_RATE_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_MACRO_CONVERSION_RATE_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_MACRO_CONVERSION_RATE_POSITION_BASED,
  },
  [AttributionMetric.PROFIT]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_PROFIT,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_PROFIT_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_PROFIT_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_PROFIT_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_PROFIT_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_PROFIT_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_PROFIT_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_PROFIT_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_PROFIT_POSITION_BASED,
  },
  [AttributionMetric.NET_REVENUE]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_NET_REVENUE,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_NET_REVENUE_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_NET_REVENUE_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_NET_REVENUE_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_NET_REVENUE_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_NET_REVENUE_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_NET_REVENUE_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_NET_REVENUE_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_NET_REVENUE_POSITION_BASED,
  },
  [AttributionMetric.ROI]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_ROI,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_ROI_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_ROI_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_ROI_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_ROI_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_ROI_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_ROI_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_ROI_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_ROI_POSITION_BASED,
  },
  [AttributionMetric.LTV]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_LTV,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_LTV_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_LTV_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_LTV_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_LTV_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_LTV_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_LTV_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_LTV_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_LTV_POSITION_BASED,
  },
  [AttributionMetric.ROILTV]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_ROI_LTV,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_ROI_LTV_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_ROI_LTV_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_ROI_LTV_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_ROI_LTV_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_ROI_LTV_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_ROI_LTV_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_ROI_LTV_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_ROI_LTV_POSITION_BASED,
  },
  [AttributionMetric.ROAS]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_ROAS,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_ROAS_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_ROAS_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_ROAS_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_ROAS_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_ROAS_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_ROAS_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_ROAS_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_ROAS_POSITION_BASED,
  },
  [AttributionMetric.ROASLTV]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_ROAS_LTV,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_ROAS_LTV_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_ROAS_LTV_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_ROAS_LTV_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_ROAS_LTV_LINEAR,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_ROAS_LTV_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_ROAS_LTV_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_ROAS_LTV_CUSTOM,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_ROAS_LTV_POSITION_BASED,
  },
  [AttributionMetric.CUMULATIVE_LTV]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_CUMULATIVE_LTV,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_CUMULATIVE_LTV_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_CUMULATIVE_LTV_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_CUMULATIVE_LTV_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_CUMULATIVE_LTV_LINEAR,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_CUMULATIVE_LTV_POSITION_BASED,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_CUMULATIVE_LTV_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_CUMULATIVE_LTV_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_CUMULATIVE_LTV_CUSTOM,
  },
  [AttributionMetric.CUMULATIVE_LTV_PROFIT]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_CUMULATIVE_LTV_PROFIT,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_CUMULATIVE_LTV_PROFIT_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_CUMULATIVE_LTV_PROFIT_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_CUMULATIVE_LTV_PROFIT_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_CUMULATIVE_LTV_PROFIT_LINEAR,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_CUMULATIVE_LTV_PROFIT_POSITION_BASED,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_CUMULATIVE_LTV_PROFIT_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_CUMULATIVE_LTV_PROFIT_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_CUMULATIVE_LTV_PROFIT_CUSTOM,
  },
  [AttributionMetric.NEW_CUSTOMER]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_NEW_CUSTOMERS_COUNT,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_NEW_CUSTOMERS_COUNT_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_NEW_CUSTOMERS_COUNT_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_NEW_CUSTOMERS_COUNT_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_NEW_CUSTOMERS_COUNT_LINEAR,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_NEW_CUSTOMERS_COUNT_POSITION_BASED,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_NEW_CUSTOMERS_COUNT_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_NEW_CUSTOMERS_COUNT_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_NEW_CUSTOMERS_COUNT_CUSTOM,
  },
  [AttributionMetric.CAC]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_CAC,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_CAC_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_CAC_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_CAC_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_CAC_LINEAR,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_CAC_POSITION_BASED,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_CAC_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_CAC_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_CAC_CUSTOM,
  },
  [AttributionMetric.AOV]: {
    [ApiAttributionModel.NO_MODEL_SELECTED]: ApiMetric.METRIC_AVERAGE_SALE_VALUE,
    [ApiAttributionModel.FIRST]: ApiMetric.METRIC_AVERAGE_SALE_VALUE_FIRST,
    [ApiAttributionModel.LAST]: ApiMetric.METRIC_AVERAGE_SALE_VALUE_LAST,
    [ApiAttributionModel.LAST_NON_DIRECT]: ApiMetric.METRIC_AVERAGE_SALE_VALUE_LAST_NON_DIRECT,
    [ApiAttributionModel.LINEAR]: ApiMetric.METRIC_AVERAGE_SALE_VALUE_LINEAR,
    [ApiAttributionModel.POSITION_BASED]: ApiMetric.METRIC_AVERAGE_SALE_VALUE_POSITION_BASED,
    [ApiAttributionModel.IMPACTED]: ApiMetric.METRIC_AVERAGE_SALE_VALUE_IMPACTED,
    [ApiAttributionModel.EBA]: ApiMetric.METRIC_AVERAGE_SALE_VALUE_EBA,
    [ApiAttributionModel.CUSTOM]: ApiMetric.METRIC_AVERAGE_SALE_VALUE_CUSTOM,
  },
};

// Create reverse mapping for efficient lookup
const metricToAttributionMap = new Map<ApiMetric, { attribtionType: ApiAttributionModel; attribtionMetric: AttributionMetric }>();

// Build the reverse mapping from the groups
Object.entries(attributionMetricGroups).forEach(([attributionMetric, modelMap]) => {
  Object.entries(modelMap).forEach(([model, metric]) => {
    metricToAttributionMap.set(metric, {
      attribtionType: model as ApiAttributionModel,
      attribtionMetric: attributionMetric as AttributionMetric,
    });
  });
});

// Clean attribution mapping function
export const getAttributionMapping = (metric: ApiMetric): {
  attribtionType?: ApiAttributionModel;
  attribtionMetric?: AttributionMetric
} => {
  return metricToAttributionMap.get(metric) || {};
};

// Helper functions to find metrics by attribution
export const metricByAttribution = (
  type: ApiAttributionModel,
  metric: AttributionMetric
): ApiMetric | undefined => {
  return attributionMetricGroups[metric]?.[type];
};

export const metricsByAttributionModelType = (type: ApiAttributionModel): ApiMetric[] => {
  const metrics: ApiMetric[] = [];
  Object.values(attributionMetricGroups).forEach(modelMap => {
    const metric = modelMap[type];
    if (metric) {
      metrics.push(metric);
    }
  });
  return metrics;
};

export const metricsByAttribution = (type: AttributionMetric): ApiMetric[] => {
  return Object.values(attributionMetricGroups[type] || {});
};

export const allAttributionMetrics = (): ApiMetric[] => {
  return Array.from(metricToAttributionMap.keys());
};

/**
 * Check if a metric is an attribution metric
 */
export const isAttributionMetric = (metric: ApiMetric): boolean => {
  const mapping = getAttributionMapping(metric);
  return mapping?.attribtionMetric !== undefined;
};

/**
 * Media spend related attribution metrics that should be excluded for organic traffic
 */
const mediaSpendAttributionMetrics = [
  AttributionMetric.ROI,
  AttributionMetric.ROILTV,
  AttributionMetric.ROAS,
  AttributionMetric.ROASLTV,
  AttributionMetric.CAC,
];


export const attributionMetricsThatUseSpend = (): ApiMetric[] =>
  mediaSpendAttributionMetrics.flatMap((m) => metricsByAttribution(m));

export const excludeMediaSpendMetrics = (metrics: ApiMetric[]): ApiMetric[] => {
  return metrics.filter((metric) => {
    const mapping = getAttributionMapping(metric);
    if (!mapping?.attribtionMetric) {
      // If it's not an attribution metric, keep it
      return true;
    }
    return !mediaSpendAttributionMetrics.includes(mapping.attribtionMetric);
  });
};
